// caso de uso con evento - application layer

import { MovimientoInventario } from "../domain/agreggates/MovimientoInventario.aggregate.js";
import { MovimientoInventarioRepository } from "../infrastructure/supabase/movimientoInventarioRepository.repository.js";
import { domainEventDispatcher } from "../domain/events/DomainEventDispatcher.js";


export async function registrarEntradaInventarioUseCase(params) {
  console.log("[Application][UseCase] Params recibidos:", params);

  const {
    idProducto,
    cantidad,
    idReferencia = 9999,
    origen = "Ajuste",
    tipoMovimiento = "entrada",
    createdBy = 3,
    periodoId,
  } = params;

  if (!idProducto) throw new Error("[Application][UseCase] ID de producto requerido");
  if (!cantidad || cantidad <= 0) throw new Error("[Application][UseCase] Cantidad debe ser mayor a 0");
  if (!idReferencia) throw new Error("[Application][UseCase] ID de referencia requerido");
  if (!periodoId) throw new Error("[Application][UseCase] Periodo requerido");

  // 1️⃣ Crear aggregate
  const movimientoAggregate = new MovimientoInventario({ periodoId, createdBy });
  console.log("[Domain][Aggregate] Aggregate creado");

  // 2️⃣ Crear movimiento dentro del aggregate
  const movimiento = movimientoAggregate.agregarAjuste({
    idProducto,
    cantidad,
    idReferencia,
    origen,
    tipoMovimiento,
  });
  console.log("[Domain][Aggregate] Movimiento generado:", movimiento);


  // 3️⃣ Crear instancia del repositorio
  const movimientoRepository = new MovimientoInventarioRepository();

  // 4️⃣ Guardar usando el repositorio
  const guardado = await movimientoRepository.insertarMovimientoInventario(movimiento);

  console.log("[Repository] Movimiento guardado:", guardado);

  // 5️⃣ Crear evento
  const evento = movimientoAggregate.crearEvento(guardado);

  console.log("[Aggregate] Evento creado:", evento);

  // 6️⃣ Despachar evento
  await domainEventDispatcher.dispatch(evento);

  console.log("[Dispatcher] Evento despachado");

  // 7️⃣ Limpiar eventos
  movimientoAggregate.limpiarEventos();

  console.log("[Aggregate] Eventos limpiados");

  return guardado;
}